
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Subtraction 11","d":"M14.19 20H5.81C2.172 20 0 17.824 0 14.18V5.81C0 2.172 2.172 0 5.81 0h8.38C17.828 0 20 2.172 20 5.81v8.38c0 3.638-2.172 5.81-5.81 5.81zM3.847 13.692a9.177 9.177 0 004.333 1.186 6.62 6.62 0 001.841-.254 6.768 6.768 0 004.708-4.764 8.52 8.52 0 00.306-2.309 4.072 4.072 0 01.316-.672v-.008a10.656 10.656 0 00.8-1.788 7.559 7.559 0 01-1.391.481h-.009c-.146.04-.3.081-.446.125a1.991 1.991 0 00-1.556-.678 3.269 3.269 0 00-1.14.223 2.418 2.418 0 00-1.613 2.3v.615h-.16a5.8 5.8 0 01-4.762-2.463 5.5 5.5 0 00-.447 3.946 4.872 4.872 0 002.908 2.822 6.072 6.072 0 01-3.494 1.235c-.063.011-.13.006-.194.003z","fill":"#acb2bf"}})])
          )
        }
      }
    